import React from 'react';
import { GIS_ZHKH_PRICE_LABEL } from './constants';

const GisZhkkhSubscribeNotice = () => (
  <div className="mb-4 rounded-2xl bg-orange-50 px-3 py-2 text-sm text-gray-700">
    Платная подписка {GIS_ZHKH_PRICE_LABEL}. После оформления вы будете перенаправлены на оплату. Поиск прибора в ГИС ЖКХ может занять несколько секунд.
  </div>
);

export default GisZhkkhSubscribeNotice;
